import type { CommissioningMessage as Msg } from '@/stores/useAuthorCommissioningStore'

export function CommissioningMessage({ message }: { message: Msg }) {
  const cls =
    message.role === 'user'
      ? 'author-message author-message--user'
      : 'author-message author-message--studio'
  return <div className={cls}>{message.content}</div>
}
